import { Navigate } from "react-router-dom";
import { useAuthContext } from "contexts/AuthContext/context";

export default function Home() {
  // Get partner
  const { authState } = useAuthContext();
  const { partner } = authState;

  // If there is a partner go to profile
  return partner ? (
    <Navigate to="/private/profile" />
  ) : (
    // If there isn't partner go to login
    <Navigate to="/login" />
  );
}
